import styled from 'styled-components'

export const SidebarInput = styled.input`
   cursor: pointer;
   margin-left: 10px;
   margin-right: 10px;
`